import { gql } from '@apollo/client'

// GraphQL Query: Fetch media by mediaId for content detail media field
export const GET_MEDIA_BY_ID = gql`
  query GetMediaById($mediaId: ID!) {
    mediaList(where: { mediaId: { eq: $mediaId } }) {
      media {
        mediaId
        contentId
        policyId
        mediaMaestroTitleCode
        updatedAt
        duration
        isPublished
        mediaAssets {
          id
          providerKey
          originalFileName
          updatedAt
          language
          mediaReferenceType
          duration
          url
        }
      }
    }
  }
`

export const GET_MEDIA_SUGGESTIONS = gql`
  query GetMediaSuggestions($contentId: String!, $limit: Int!) {
    mediaList(
      where: { contentId: { ilike: $contentId } }
      limit: $limit
      order: [["createdAt", "DESC"]]
    ) {
      media {
        mediaId
        contentId
        createdAt
      }
    }
  }
`
